import { AddToCurrentCartFailedError } from '../CartsState';
import { RootState } from '../../RootState';

const selectAddToCurrentCartFailedReason = (
  state: RootState,
  actionId: number
): AddToCurrentCartFailedError | undefined => {
  const failedAction = state.carts.pageActions.addToCurrentCart.failed.find(
    (action) => action.requestedActionId === actionId
  );
  return failedAction?.failedReason;
};

export default selectAddToCurrentCartFailedReason;
